import React, { useRef, useEffect, useMemo } from "react";
import DashboardMainContainer from "../common/Containers/DashboardMainContainer";
import { AdminMetric, AdminSupportingText } from "../../sections/AdminDashboard/shared/adminUx";
import { AdminWidgetHeader } from "./AdminWidgetChrome";
import {
  dashboardChartTooltipHeading,
  dashboardChartTooltipSeriesRow,
} from "./dashboardChartTooltip";
import * as echarts from "echarts";

const ReviewsOverTimeWidget = () => {
  const chartRef = useRef(null);

  const reviewsData = useMemo(
    () => ({
      weeks: ["Aug 12", "Aug 19", "Aug 26", "Sep 2", "Sep 9", "Sep 16", "Sep 23"],
      values: [0, 2, 4, 5, 7, 8, 10],
      totalReviews: 101,
    }),
    []
  );

  useEffect(() => {
    if (!chartRef.current) return;
    const chartInstance = echarts.init(chartRef.current);

    const option = {
      grid: { left: 0, right: 0, top: 0, bottom: 16 },
      tooltip: {
        trigger: "axis",
        backgroundColor: "#FFFFFF",
        borderColor: "#E5E7EB",
        borderWidth: 1,
        textStyle: { color: "#232A2E", fontSize: 11, fontWeight: 500 },
        axisPointer: { type: "line", lineStyle: { color: "#A78BFA", width: 1 } },
        renderMode: "html",
        formatter(params) {
          const p = Array.isArray(params) ? params[0] : params;
          const label = reviewsData.weeks[p.dataIndex] || p.name || "";
          return (
            dashboardChartTooltipHeading(label) +
            dashboardChartTooltipSeriesRow(p, "Reviews")
          );
        },
      },
      xAxis: {
        type: "category",
        data: reviewsData.weeks,
        boundaryGap: false,
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: {
          show: true,
          color: "#6B7280",
          fontSize: 10,
          margin: 10,
          formatter(value, index) {
            if (index === 0 || index === reviewsData.weeks.length - 1) return value;
            return "";
          },
        },
        splitLine: { show: false },
      },
      yAxis: {
        type: "value",
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitLine: { show: false },
        min: 0,
        max: 15,
      },
      series: [
        {
          type: "line",
          data: reviewsData.values,
          smooth: true,
          symbol: "none",
          lineStyle: { color: "#A78BFA", width: 3 },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{ offset: 0, color: "rgba(167, 139, 250, 0.3)" }],
            },
          },
        },
      ],
    };

    chartInstance.setOption(option);
    const handleResize = () => chartInstance.resize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      chartInstance.dispose();
    };
  }, [reviewsData]);

  return (
    <DashboardMainContainer className="masonry-item w-[505px] h-[400px] flex flex-col">
      <AdminWidgetHeader title="Reviews Over Time" />
      <div className="flex-1 p-4">
        <div className="mb-4">
          <AdminMetric size="large" className="text-offblack block">
            {reviewsData.totalReviews}
          </AdminMetric>
          <AdminSupportingText className="text-offblack block">Total reviews</AdminSupportingText>
        </div>
        <div ref={chartRef} className="w-full h-[15rem]" />
      </div>
    </DashboardMainContainer>
  );
};

export default ReviewsOverTimeWidget;
